export const CAT_URL = 'https://api.thecatapi.com/v1/images/search?limit=';
export const API_KEY = '17dfae07-88ff-43a9-a3fe-f783f09269e5';
